import styles from './EmployeeCard.module.scss';

import { EmployeeCardProps } from '@/types';
import { ResponsiveImage } from '@/ui';

const EmployeeCard = ({
  onCardClick,
  id,
  ...card
}: EmployeeCardProps & { onCardClick: () => void; id: string }) => {
  const { employeeName, employeeJobTitle, employeeProfileImage } = card;

  const hasImage = !!employeeProfileImage?.url;

  let setSizes = { sm: 160 };

  const handleBioModal = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    onCardClick();
  };

  return (
    <button
      id={id}
      onClick={(event) => {
        handleBioModal(event);
      }}
      className={`${styles.card} ${hasImage ? styles.hasImage : ''} `}
      type="button"
    >
      {hasImage && (
        <div className={styles.card__image}>
          <ResponsiveImage
            sizes={setSizes}
            className={styles.card__image}
            media={employeeProfileImage}
          />
        </div>
      )}

      <div className={styles.card__content}>
        <h3 className={styles.card__heading}>{employeeName}</h3>
        <p className={styles.card__subheading}>{employeeJobTitle}</p>
      </div>

      <div className={styles.card__cta}>
        <span className={styles.card__ctaArrow}></span>
      </div>

    </button>
  );
};

export default EmployeeCard;
